module.exports = __webpack_public_path__ + "img/background-main-mobile.be0bd482.svg";